import React from "react";

import { DynamicSubscriptionButton } from "scmp-app/lib/sdk/dynamics";

import {
  ButtonContainer,
  Container,
  SubscribeDetails,
  Title,
  TitleAndDetailsContainer,
} from "./styles";

export type Props = {
  className?: string;
  onClick: (destination: string) => void;
};

export const HomeFooterSubscriptionWidget: React.FunctionComponent<Props> = ({
  className,
  onClick,
}) => (
  <Container className={className}>
    <TitleAndDetailsContainer>
      <Title>Subscribe to the SCMP</Title>
      <SubscribeDetails>
        Critical insights and analysis on China that matter to the world
      </SubscribeDetails>
    </TitleAndDetailsContainer>
    <ButtonContainer onClick={() => onClick(window.location.href)}>
      <DynamicSubscriptionButton location="footer" variant="light-blue" />
    </ButtonContainer>
  </Container>
);

HomeFooterSubscriptionWidget.displayName = "HomeFooterSubscriptionWidget";
